import React from "react";
import Axios from "axios";
import axios from "services/axios";
import {
  Button,
  Card,
  message,
  Spin,
  Tooltip,
  Tag,
  Select,
  Input,
  DatePicker,
} from "antd";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import { errorMessage } from "../../Utils";
import { connect } from "react-redux";
import moment from "moment-timezone";
import ModalDownload from "./Modal/ModalDownload";
import _ from "lodash";
let cancelToken;
const { RangePicker } = DatePicker;

class EApprovalList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      branchDetail: {},
      branches: [],
      rawData: [],
      isLoading: true,
      confirmLoading: false,
      disableButton: true,
      page: 1,
      limit: 10,
      count: 0,
      search: "",
      status: props.Auth.user.role === "GENERAL_MANAGER" ? "waiting" : "new",
      sort: { name: "date", direction: "desc" },
      roleActive:
        props.Auth.user.role === "BOH"
          ? "BOH"
          : props.Auth.user.role === "GENERAL_MANAGER"
          ? "GM"
          : ["SUPER_ADMIN", "GP_ADMIN", "FINANCE"].includes(
              props.Auth.user.role
            )
          ? "ADMIN"
          : "Salesman",
      // roleActive: props.history.location.pathname.includes("boh") ? "BOH" : props.history.location.pathname.includes("gm") ? "GM" : "Salesman",
      tabs: ["New", "Approval", "SPK", "Done", "Reject/Cancel"],
      tabsBOH: [
        "New",
        "Waiting Approval",
        "SPK Validation",
        "Done",
        "Rejected",
      ],
      tabsGM: ["Waiting", "SPK Validation", "Done", "Reject/Cancel"],
      tabActive: { name: "New", index: 0 },
      tabActiveBOH: { name: "New", index: 0 },
      tabActiveGM: { name: "Waiting", index: 0 },
      startDate: "",
      endDate: "",
      visibleModalDownload: false,
    };
  }

  async componentDidMount() {
    let { page, limit, search, status, startDate, endDate } = this.state;
    await this.getLocalStoragePageActive({
      page,
      limit,
      search,
      status,
      startDate,
      endDate,
    });
    this.fetchData();
  }

  async getLocalStoragePageActive(
    page,
    limit,
    search,
    status,
    startDate,
    endDate
  ) {
    let eApprovalPage = await localStorage.getItem("EApprovalPage");
    if (eApprovalPage) {
      eApprovalPage = JSON.parse(eApprovalPage);
      page = parseInt(eApprovalPage.page) || 1;
      limit = parseInt(eApprovalPage.limit) || 10;
      search = eApprovalPage["search"] || "";
      startDate = eApprovalPage.startDate || "";
      endDate = eApprovalPage.endDate || "";
      status =
        eApprovalPage.status ||
        (this.props.Auth.user.role === "GENERAL_MANAGER" ? "waiting" : "new");

      this.setState({
        page,
        limit,
        status,
        search,
        tabActive: eApprovalPage.tabActive || { name: "New", index: 0 },
        tabActiveBOH: eApprovalPage.tabActiveBOH || { name: "New", index: 0 },
        tabActiveGM: eApprovalPage.tabActiveGM || { name: "New", index: 0 },
        startDate,
        endDate,
      });
    }
    return;
  }

  async setLocalStoragePageActive() {
    let {
      page,
      limit,
      search,
      status,
      startDate,
      endDate,
      tabActive,
      tabActiveBOH,
      tabActiveGM,
    } = this.state;

    localStorage.setItem(
      "EApprovalPage",
      JSON.stringify({
        page,
        limit,
        search,
        status,
        startDate,
        endDate,
        tabActive,
        tabActiveBOH,
        tabActiveGM,
      })
    );
  }

  async fetchData() {
    await this.setLocalStoragePageActive();
    const { page, limit, search, status, startDate, endDate } = this.state;

    this.setState({ isLoading: true, rawData: [] });
    const query = `${status}?limit=${limit}&page=${page}&search=${
      search ? search : ""
    }&startDate=${startDate}&endDate=${endDate}`;
    if (cancelToken) {
      cancelToken.cancel("Operation canceled due to new request");
    }

    cancelToken = Axios.CancelToken.source();

    await axios
      .get(`car-sales/status/${query}`)
      .then((result) => {
        this.setState({
          rawData: result.data.carSales,
          page: result.data.page,
          limit: result.data.limit,
          count: result.data.count,
          isLoading: false,
        });
      })
      .catch((err) => {
        if (!Axios.isCancel(err)) {
          errorMessage(err.response || err);
          this.setState({ isLoading: false });
        }
      });
  }

  changePage(page, limit, search, status, startDate, endDate) {
    this.setState(
      {
        isLoading: true,
        page,
        limit,
        search: search ? search : "",
        status,
        startDate,
        endDate,
      },
      () => this.fetchData()
    );
  }

  getMuiTheme = () =>
    createMuiTheme({
      typography: {
        useNextVariants: true,
      },
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            "white-space": "nowrap",
            "&:nth-child(1)": {
              width: "8em",
              "min-width": "8em",
              "max-width": "10em",
              "word-break": "break-all",
            },
          },
        },
      },
    });

  handleTab = (roleActive, item, index) => {
    const { page, limit, search, status, startDate, endDate } = this.state;
    // new, waiting, approved, reject, cancel, spk
    let selectedStatus = item.includes("Waiting")
      ? "waiting"
      : item.includes("SPK")
      ? "spk"
      : item.includes("Reject")
      ? "reject_cancel"
      : item.toLowerCase();
    this.setState({ isLoading: true, status: selectedStatus, rawData: [] });
    switch (roleActive) {
      case "Salesman":
      case "ADMIN":
        this.setState({ tabActive: { name: item, index }, page: 1 }, () =>
          this.fetchData()
        );
        break;
      case "BOH":
        this.setState({ tabActiveBOH: { name: item, index }, page: 1 }, () =>
          this.fetchData()
        );
        break;
      case "GM":
        this.setState({ tabActiveGM: { name: item, index }, page: 1 }, () =>
          this.fetchData()
        );
        break;
      default:
        break;
    }
  };

  render() {
    const { Auth } = this.props;
    let { page, limit, search, status, startDate, endDate } = this.state;
    let {
      tabs,
      tabActive,
      tabsBOH,
      tabActiveBOH,
      tabsGM,
      tabActiveGM,
      roleActive,
      rawData,
      visibleModalDownload,
    } = this.state;
    //Columns
    const columns = [
      {
        name: "Action",
        options: {
          sort: false,
        },
      },
      {
        name: "Status",
        options: {
          sort: false,
          // display: tabActive.name === "Approval" || tabActive.name === "Reject/Cancel"
        },
      },
      {
        name: "Car Sales ID",
        options: {
          sort: false,
        },
      },
      {
        name: "Nama Unit",
        options: {
          sort: false,
        },
      },
      {
        name: "No Polisi",
        options: {
          sort: false,
        },
      },
      {
        name: "Product Type",
        options: {
          sort: false,
        },
      },
      {
        name: "BOH",
        options: {
          sort: false,
        },
      },
      {
        name: "GM",
        options: {
          sort: false,
        },
      },
      {
        name: "Area",
        options: {
          sort: false,
        },
      },
      {
        name: "Branch",
        options: {
          sort: false,
        },
      },
      {
        name: "Tanggal Dibuat",
        options: {
          sort: false,
        },
      },
      {
        name: "Tanggal Update",
        options: {
          sort: false,
        },
      },
    ];

    const columnsBOH = [
      {
        name: "Action",
        options: {
          sort: false,
        },
      },
      {
        name: "Status",
        options: {
          sort: false,
        },
      },
      {
        name: "Car Sales ID",
        options: {
          sort: false,
        },
      },
      {
        name: "Nama Salesman",
        options: {
          sort: false,
        },
      },
      {
        name: "No Polisi",
        options: {
          sort: false,
        },
      },
      {
        name: "Product Type",
        options: {
          sort: false,
        },
      },

      {
        name: "BOH",
        options: {
          sort: false,
        },
      },
      {
        name: "GM",
        options: {
          sort: false,
        },
      },
      {
        name: "Area",
        options: {
          sort: false,
        },
      },
      {
        name: "Branch",
        options: {
          sort: false,
        },
      },
      {
        name: "Tanggal Dibuat",
        options: {
          sort: false,
        },
      },
      {
        name: "Tanggal Update",
        options: {
          sort: false,
        },
      },
    ];

    const columnsGM = [
      {
        name: "Action",
        options: {
          sort: false,
        },
      },
      {
        name: "Status",
        options: {
          sort: false,
        },
      },
      {
        name: "Car Sales ID",
        options: {
          sort: false,
        },
      },
      {
        name: "Nama Salesman",
        options: {
          sort: false,
        },
      },
      {
        name: "No Polisi",
        options: {
          sort: false,
        },
      },
      {
        name: "Product Type",
        options: {
          sort: false,
        },
      },
      {
        name: "BOH",
        options: {
          sort: false,
        },
      },
      {
        name: "GM",
        options: {
          sort: false,
        },
      },
      {
        name: "Area",
        options: {
          sort: false,
        },
      },
      {
        name: "Branch",
        options: {
          sort: false,
        },
      },
      {
        name: "Tanggal Dibuat",
        options: {
          sort: false,
        },
      },
      {
        name: "Tanggal Update",
        options: {
          sort: false,
        },
      },
    ];

    const carSales = rawData.map((item, index) => {
      let bohName =
        _.get(item, "SalesProfile.SalesBranch.AreaBranch.User.name") || "-";
      let gmName =
        _.get(
          item,
          "SalesProfile.SalesBranch.AreaBranch.GeneralManager.name"
        ) || "-";
      let areaName =
        _.get(item, "SalesProfile.SalesBranch.AreaBranch.name") || "-";
      let branchName = _.get(item, "SalesProfile.SalesBranch.branch") || "-";
      return [
        <div>
          <Tooltip placement="bottom" title="Detail Data">
            <Button
              icon="bars"
              style={{ marginRight: 10 }}
              onClick={() =>
                this.props.history.push({
                  pathname: `/home/e-approval/selling-system/detail/${item.id}`,
                  state: { id: item.id, status },
                })
              }
            />
          </Tooltip>
          {tabActive.name === "New" && Auth.user.role === "SALES_USER" ? (
            <Tooltip placement="bottom" title="Update Data">
              <Button
                type="primary"
                icon="edit"
                onClick={() =>
                  this.props.history.push({
                    pathname: `/home/e-approval/selling-system/update/${item.id}`,
                    state: { id: item.id, status },
                  })
                }
              />
            </Tooltip>
          ) : null}
        </div>,
        <Tag
          color={
            item.status === "New"
              ? "cyan"
              : item.status.includes("Waiting")
              ? "orange"
              : item.status === "Approved"
              ? "green"
              : item.status === "Done"
              ? "blue"
              : item.status === "SPK Reject"
              ? "magenta"
              : item.status.includes("Reject")
              ? "red"
              : item.status.includes("Cancel")
              ? "volcano"
              : "gold"
          }>
          {item.status}
        </Tag>,
        item.code,
        item.carName,
        item.licensePlate,
        item.productType,
        bohName,
        gmName,
        areaName,
        branchName,
        item.createdAt
          ? moment(item.createdAt).format("DD MMMM YYYY HH:mm")
          : "-",
        item.updatedAt
          ? moment(item.updatedAt).format("DD MMMM YYYY HH:mm")
          : "-",
      ];
    });

    const carSalesBOH = rawData.map((item, index) => {
      let bohName =
        _.get(item, "SalesProfile.SalesBranch.AreaBranch.User.name") || "-";
      let gmName =
        _.get(
          item,
          "SalesProfile.SalesBranch.AreaBranch.GeneralManager.name"
        ) || "-";
      let areaName =
        _.get(item, "SalesProfile.SalesBranch.AreaBranch.name") || "-";
      let branchName = _.get(item, "SalesProfile.SalesBranch.branch") || "-";
      return [
        <div>
          <Tooltip placement="bottom" title="Detail Data">
            <Button
              icon="bars"
              style={{ marginRight: 10 }}
              onClick={() =>
                this.props.history.push({
                  pathname: `/home/e-approval/selling-system/boh/detail/${item.id}`,
                  state: { status, id: item.id },
                })
              }
            />
          </Tooltip>
        </div>,
        <Tag
          color={
            item.status === "New"
              ? "cyan"
              : item.status.includes("Waiting")
              ? "orange"
              : item.status === "Approved"
              ? "green"
              : item.status === "Done"
              ? "blue"
              : item.status === "SPK Reject"
              ? "magenta"
              : item.status.includes("Reject")
              ? "red"
              : item.status.includes("Cancel")
              ? "volcano"
              : "gold"
          }>
          {item.status}
        </Tag>,
        item.code,
        item.SalesProfile.name,
        item.licensePlate,
        item.productType,
        bohName,
        gmName,
        areaName,
        branchName,
        item.createdAt
          ? moment(item.createdAt).format("DD MMMM YYYY HH:mm")
          : "-",
        item.updatedAt
          ? moment(item.updatedAt).format("DD MMMM YYYY HH:mm")
          : "-",
      ];
    });

    const carSalesGM = rawData.map((item, index) => {
      let bohName =
        _.get(item, "SalesProfile.SalesBranch.AreaBranch.User.name") || "-";
      let gmName =
        _.get(
          item,
          "SalesProfile.SalesBranch.AreaBranch.GeneralManager.name"
        ) || "-";
      let areaName =
        _.get(item, "SalesProfile.SalesBranch.AreaBranch.name") || "-";
      let branchName = _.get(item, "SalesProfile.SalesBranch.branch") || "-";
      return [
        <div>
          <Tooltip placement="bottom" title="Detail Data">
            <Button
              icon="bars"
              style={{ marginRight: 10 }}
              onClick={() =>
                this.props.history.push({
                  pathname: `/home/e-approval/selling-system/gm/detail/${item.id}`,
                  state: { status, id: item.id },
                })
              }
            />
          </Tooltip>
        </div>,
        <Tag
          color={
            item.status === "New"
              ? "cyan"
              : item.status.includes("Waiting")
              ? "orange"
              : item.status === "Approved"
              ? "green"
              : item.status === "Done"
              ? "blue"
              : item.status === "SPK Reject"
              ? "magenta"
              : item.status.includes("Reject")
              ? "red"
              : item.status.includes("Cancel")
              ? "volcano"
              : "gold"
          }>
          {item.status}
        </Tag>,
        item.code,
        item.SalesProfile.name,
        item.licensePlate,
        item.productType,
        bohName,
        gmName,
        areaName,
        branchName,
        item.createdAt
          ? moment(item.updatedAt).format("DD MMMM YYYY HH:mm")
          : "-",
        item.updatedAt
          ? moment(item.updatedAt).format("DD MMMM YYYY HH:mm")
          : "-",
      ];
    });

    const carSalesAdmin = rawData.map((item, index) => {
      let bohName =
        _.get(item, "SalesProfile.SalesBranch.AreaBranch.User.name") || "-";
      let gmName =
        _.get(
          item,
          "SalesProfile.SalesBranch.AreaBranch.GeneralManager.name"
        ) || "-";
      let areaName =
        _.get(item, "SalesProfile.SalesBranch.AreaBranch.name") || "-";
      let branchName = _.get(item, "SalesProfile.SalesBranch.branch") || "-";
      return [
        <div>
          <Tooltip placement="bottom" title="Detail Data">
            <Button
              icon="bars"
              style={{ marginRight: 10 }}
              onClick={() =>
                this.props.history.push({
                  pathname: `/home/e-approval/selling-system/admin/detail/${item.id}`,
                  state: { status, id: item.id },
                })
              }
            />
          </Tooltip>
        </div>,
        <Tag
          color={
            item.status === "New"
              ? "cyan"
              : item.status.includes("Waiting")
              ? "orange"
              : item.status === "Approved"
              ? "green"
              : item.status === "Done"
              ? "blue"
              : item.status === "SPK Reject"
              ? "magenta"
              : item.status.includes("Reject")
              ? "red"
              : item.status.includes("Cancel")
              ? "volcano"
              : "gold"
          }>
          {item.status}
        </Tag>,
        item.code,
        item.carName,
        item.licensePlate,
        item.productType,
        bohName,
        gmName,
        areaName,
        branchName,
        item.createdAt
          ? moment(item.createdAt).format("DD MMMM YYYY HH:mm")
          : "-",
        item.updatedAt
          ? moment(item.updatedAt).format("DD MMMM YYYY HH:mm")
          : "-",
      ];
    });

    //Options
    const options = {
      filter: false,
      responsive: "simple",
      fixedHeader: true,
      tableBodyHeight: "460px",
      print: false,
      selectableRows: "none",
      // resizableColumns: true,
      download: false,
      viewColumns: false,
      serverSide: true,
      rowsPerPage: this.state.limit,
      count: this.state.count,
      page: this.state.page - 1,
      searchText: search,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.changePage(
              tableState.page + 1,
              tableState.rowsPerPage,
              search,
              status,
              startDate,
              endDate
            );
            break;
          case "changeRowsPerPage":
            this.changePage(
              1,
              tableState.rowsPerPage,
              search,
              status,
              startDate,
              endDate
            );
            break;
          case "search":
            this.setState({ search: tableState.searchText }, () =>
              this.changePage(
                1,
                tableState.rowsPerPage,
                tableState.searchText,
                status,
                startDate,
                endDate
              )
            );
            break;
          default:
            break;
        }
      },
    };

    let tab =
      roleActive === "Salesman" || roleActive === "ADMIN"
        ? tabs
        : roleActive === "BOH"
        ? tabsBOH
        : tabsGM;
    let selectedTab =
      roleActive === "Salesman" || roleActive === "ADMIN"
        ? tabActive
        : roleActive === "BOH"
        ? tabActiveBOH
        : tabActiveGM;
    console.log(startDate, endDate, "startDate, endDate");
    return (
      <Card
        title="Selling System"
        style={{
          marginTop: 35,
          background: "#fff",
          minHeight: 360,
        }}>
        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <div
            style={{
              margin: 15,
              display: "flex",
              justifyContent: "flex-start",
              width: "50%",
            }}>
            {tab.map((item, index) => {
              return (
                <div
                  key={index}
                  style={{
                    backgroundColor:
                      selectedTab.index === index ? "#F4F9FF" : "transparent",
                    color: selectedTab.index === index ? "#005596" : "#4B5565",
                    padding: 10,
                    borderRadius: 8,
                    cursor: "pointer",
                  }}
                  onClick={() => this.handleTab(roleActive, item, index)}>
                  {item}
                </div>
              );
            })}
          </div>

          <div style={{ margin: 15, float: "right", display: "flex" }}>
            {roleActive === "Salesman" ? (
              <RangePicker
                style={{ margin: "0 10px" }}
                format="YYYY-MM-DD"
                onChange={(date, dateString) => {
                  let start = dateString[0] ? dateString[0] : "";
                  let end = dateString[1] ? dateString[1] : "";
                  this.setState(
                    {
                      startDate: start,
                      endDate: end,
                    },
                    () => this.fetchData()
                  );
                }}
                value={
                  startDate && endDate
                    ? [moment(startDate), moment(endDate)]
                    : []
                }
              />
            ) : null}

            {Auth.user.role !== "SALES_USER" ? (
              <Button
                icon={"download"}
                style={{
                  marginRight: 8,
                  backgroundColor: "#000",
                  color: "#FFF",
                }}
                onClick={() => this.setState({ visibleModalDownload: true })}>
                Download Report
              </Button>
            ) : null}

            {Auth.user.role === "SALES_USER" ? (
              <Link
                to={{
                  pathname: `/home/e-approval/selling-system/create`,
                }}>
                <Button
                  style={{
                    marginRight: 8,
                    backgroundColor: "#005596",
                    color: "#FFF",
                  }}>
                  Create Discount +
                </Button>
              </Link>
            ) : null}
          </div>
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title="Selling System"
              data={
                roleActive === "Salesman"
                  ? carSales
                  : roleActive === "BOH"
                  ? carSalesBOH
                  : roleActive === "ADMIN"
                  ? carSalesAdmin
                  : carSalesGM
              }
              columns={
                roleActive === "Salesman" || roleActive === "ADMIN"
                  ? columns
                  : roleActive === "BOH"
                  ? columnsBOH
                  : columnsGM
              }
              options={options}
            />
          </MuiThemeProvider>

          {this.props.Auth.user.role != "SALES_USER" && (
            <ModalDownload
              type={"e-approval"}
              visible={visibleModalDownload}
              visibleModal={(value) =>
                this.setState({ visibleModalDownload: value })
              }
              status={"e-approval"}
              role={Auth.user.role}
              listStatus={tab}
              eApprovalStatus={status}
            />
          )}
        </Spin>
      </Card>
    );
  }
}

const mapStateToProps = ({ Auth, Bidding, Area }) => ({ Auth, Bidding, Area });

export default connect(mapStateToProps)(EApprovalList);



// WEBPACK FOOTER //
// src/components/Dashboard/EApproval/EApprovalList.js